<template>
  <br />
</template>

<script setup>
import { fieldFactory } from '@/helper/popFieldFactory';
const props = defineProps({
    popStoreId:String
})

const popBreak = fieldFactory('popBreak', props.popStoreId)
</script>

<style>

</style>